'use client'
import React from 'react'
import TeamPlaceholder from '@/assets/images/placeholder/team.png'
import MyImage from '../myImage'
import { getImgURL } from '@/shared/utils'
import CustomLink from '../customLink'

function TeamSquads({ teams }: any) {
  return (
    <div className='flex md:flex-wrap overflow-x-auto gap-4 '>
      {teams?.slice(0,5)?.map((team: any) => (
        <CustomLink
          key={team.id}
          href={`/${team?.oSeo?.sSlug}`}
          className='md:w-[calc(100%/5-13px)] w-[140px] bg-headersActive px-4 py-7 md:p-6 text-center rounded-xl flex-shrink-0'
        >
          <div className={` w-12 h-12 md:h-[60px] md:w-[60px] overflow-hidden mx-auto mb-4`}>
            <MyImage
              className='rounded-full aspect-square'
              src={getImgURL(team?.oImg?.sUrl)}
              alt={team?.sAbbr}
              width={60}
              placeholderImage={TeamPlaceholder}
              height={60}
            />
          </div>
          <h3 className='text-sm md:text-lg font-medium mb-0 hover:text-primary-500 text-t-origin'>{team?.sAbbr}</h3>
        </CustomLink>
      ))}
    </div>
  )
}

export default TeamSquads
